import { ConfigData } from '../../types';

const initialState: any = null;

interface ReduxProps {
  type: string;
  value: ConfigData | null;
}

export default (state = initialState, { type, value }: ReduxProps): ConfigData => {
  switch (type) {
    case 'SET_CONFIG':
      return {
        ...state,
        ...value
      };
    default:
      return state;
  }
};
